// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schuco-correction {
  min-width: 160px;
  max-width: 260px;
  white-space: normal;
}

.schuco-correction form,
.schuco-correction label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.schuco-correction input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font: inherit;
}

.schuco-correction small {
  display: block;
  color: #64748b;
  line-height: 1.4;
  margin-top: 4px;
}

.schuco-correction-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.schuco-correction button {
  padding: 4px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #f8fafc;
  color: #334155;
  font: inherit;
  cursor: pointer;
}

.schuco-correction button:hover:not(:disabled) {
  background: #e2e8f0;
}

.schuco-correction button:disabled {
  opacity: 0.6;
  cursor: wait;
}

.schuco-correction .schuco-correction-error {
  color: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/SchucoPredictionCorrection.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".schuco-correction {\n  min-width: 160px;\n  max-width: 260px;\n  white-space: normal;\n}\n\n.schuco-correction form,\n.schuco-correction label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.schuco-correction input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 6px 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  font: inherit;\n}\n\n.schuco-correction small {\n  display: block;\n  color: #64748b;\n  line-height: 1.4;\n  margin-top: 4px;\n}\n\n.schuco-correction-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.schuco-correction button {\n  padding: 4px 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #f8fafc;\n  color: #334155;\n  font: inherit;\n  cursor: pointer;\n}\n\n.schuco-correction button:hover:not(:disabled) {\n  background: #e2e8f0;\n}\n\n.schuco-correction button:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n.schuco-correction .schuco-correction-error {\n  color: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
